import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { ThreadUsageDetail } from '../pages/MeteringThreadDetail';

interface ThreadUsageModalProps {
  /** Thread to show; null/undefined keeps the modal closed. */
  threadId: string | null | undefined;
  onClose: () => void;
}

/**
 * Extra-large modal holding a thread's usage breakdown.
 *
 * Shown over the caller's page rather than navigated to, so the metering
 * dashboard's range/sort/page filters — or an embed session's scroll position —
 * survive closing it. Escape, overlay click, and the close button all dismiss
 * (all from Radix; DialogContent also scrolls its own content).
 */
export function ThreadUsageModal({ threadId, onClose }: ThreadUsageModalProps) {
  return (
    <Dialog open={!!threadId} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-[92vw] xl:max-w-[1400px] h-[90vh] p-0">
        {/* The panel renders its own visible heading; this is for screen readers. */}
        <DialogTitle className="sr-only">Thread usage detail</DialogTitle>
        {threadId ? <ThreadUsageDetail threadId={threadId} /> : null}
      </DialogContent>
    </Dialog>
  );
}
